// PageTransition.tsx
import { motion } from 'framer-motion';

export const PageTransition = ({ children }: { children: React.ReactNode }) => (
  <motion.div
    initial={{ x: '50vw', opacity: 0 }}
    animate={{ x: 0, opacity: 1, type: 'tween' }}
    transition={{ ease: 'easeInOut', duration: 0.6 }}
    style={{ width: '100%', height: '100%' }}
  >
    {children}
  </motion.div>
);
